import { gql } from '@apollo/client';

export const SAVE_LEASING_SERVICE_TYPE = gql`
  mutation saveLeasingServiceType($input: LeasingServiceTypeInput!) {
    saveLeasingServiceType(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_LEASING_SERVICE_TYPE = gql`
  mutation deleteLeasingServiceType($id: Int!) {
    deleteLeasingServiceType(id: $id) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_LEASING_SERVICE_TYPE_LINKINGS = gql`
  mutation saveLeasingServiceTypeLinkings($input: [LeasingServiceTypeLinkingInput]!) {
    saveLeasingServiceTypeLinkings(input: $input) {
      commandId
      correlationId
    }
  }
`;
